__turbopack_context__.v({
  "content": "mediaEmbed-module-scss-module__AquLzq__content",
  "fit": "mediaEmbed-module-scss-module__AquLzq__fit",
  "landscape": "mediaEmbed-module-scss-module__AquLzq__landscape",
  "mediaEmbed": "mediaEmbed-module-scss-module__AquLzq__mediaEmbed",
  "mediaImage": "mediaEmbed-module-scss-module__AquLzq__mediaImage",
  "mediaSpotify": "mediaEmbed-module-scss-module__AquLzq__mediaSpotify",
  "mediaVideo": "mediaEmbed-module-scss-module__AquLzq__mediaVideo",
  "portrait": "mediaEmbed-module-scss-module__AquLzq__portrait",
  "spotify": "mediaEmbed-module-scss-module__AquLzq__spotify",
  "spotifyContent": "mediaEmbed-module-scss-module__AquLzq__spotifyContent",
  "underlay": "mediaEmbed-module-scss-module__AquLzq__underlay",
  "underlayment": "mediaEmbed-module-scss-module__AquLzq__underlayment",
});
